import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';

interface Props {
  readonly open: boolean;
  readonly messageKey: string;
  readonly onConfirm: () => void;
  readonly onCancel: () => void;
}

/**
 * Asks before something the admin cannot take back — leaving with unsaved edits, or
 * exporting a version that is not what is on screen.
 *
 * A dialog rather than `window.confirm`: the native one cannot be styled, reads as a
 * browser malfunction next to the rest of the portal, and cannot be translated.
 */
const ConfirmDialog = ({ open, messageKey, onConfirm, onCancel }: Props): React.JSX.Element => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogContent>
        <DialogContentText>{t(messageKey)}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>{t('cancel')}</Button>
        <Button onClick={onConfirm} variant="contained" autoFocus>
          {t('confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
